import { TableColumn } from "../../../components/Table";
import React, { useCallback, useEffect } from "react";
import JobConfigView from "../../../components/JobConfigView";
import { JobType } from "../../../constants/JobTypes";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import {
  fetchJobConfigBidOptimizer,
  fetchJobRunBidOptimizer,
} from "../../../redux/bidOptimizerSlice";
import Loader from "../../../components/Loader";

const columns: TableColumn[] = [
  { key: "name", label: "Name" },
  {
    key: "createdDate",
    label: "Created Date",
    formatter: {
      type: "date",
    },
  },
  { key: "action", label: "Action" },
];

const geoBreadCrumbs = [
  {
    name: "Home",
    url: "/",
  },
  {
    name: "Buying",
    url: "/optimization/landing",
  },
  {
    name: "Bid Optimizer",
    url: "/optimization/bid-optimizer",
  },
];

const BidOptimizer: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { jobConfigList, jobRunList, loading } = useSelector(
    (state: RootState) => state.bidOptimizer
  );

  useEffect(() => {
    dispatch(fetchJobConfigBidOptimizer());
    dispatch(fetchJobRunBidOptimizer());
  }, [dispatch]);

  const handleRefresh = useCallback(() => {
    dispatch(fetchJobConfigBidOptimizer());
    dispatch(fetchJobRunBidOptimizer());
  }, [dispatch]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <JobConfigView
          jobConfigList={jobConfigList}
          jobRunList={jobRunList}
          breadCrumbs={geoBreadCrumbs}
          jobType={JobType.BidOptimizer}
          tableColumns={columns}
          onRefresh={handleRefresh}
        />
      )}
    </>
  );
};

export default BidOptimizer;
